// extracted by mini-css-extract-plugin
export default {"container":"OurTeam_container__rz8gL","content":"OurTeam_content__LA12V","topsection":"OurTeam_topsection__uT92l","name":"OurTeam_name__lzfAc","cardgroup":"OurTeam_cardgroup__x3Loo"};